import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=201a9f6c&"
import script from "./TableOfContents.vue?vue&type=script&lang=js&"
export * from "./TableOfContents.vue?vue&type=script&lang=js&"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=201a9f6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports